import { memo, type ReactNode } from 'react';

import isEqual from 'react-fast-compare';

import useAirplaneTime from '@/hooks/useAirplaneTime.js';
import type { IAirplaneInfo } from '@/pages/PlanDetail/hooks/useAirplane.js';
import { AIRPLANE_COMPANY_ICON } from '@/const.js';

const AirplaneCard = memo(
  ({
    footer,
    onClick,
    stay,
    company,
    no,
    model,
    headerRight,
    startPosition,
    endPosition,
    date,
    startTime,
    endTime,
  }: IAirplaneInfo & {
    no: string;
    footer?: ReactNode;
    onClick?: () => void;
    headerRight?: ReactNode;
    date: string;
  }) => {
    const { startTimeText, endTimeText, duration, dayDiff } = useAirplaneTime({
      date,
      startTime,
      endTime,
    });

    return (
      <article
        className='bg-[#B8FBFF] rounded-2xl   '
        onClick={onClick}
        style={{
          height: footer ? 175 : 100,
        }}
      >
        <header className='px-3 pt-3 text-xs flex items-center text-gray-700 '>
          <span className='font-[600] flex items-center '>
            {company && AIRPLANE_COMPANY_ICON[company] ? (
              <i
                className='mr-1 w-5 h-5 bg-center bg-cover block'
                style={{
                  backgroundImage: `url(${AIRPLANE_COMPANY_ICON[company]})`,
                }}
              />
            ) : (
              <i className='mr-1.5 ic-round md-airplanemode_active w-5 h-5 rotate-45 rounded-full text-white bg-blue-400 text-center leading-5 text-[13px]' />
            )}
            {footer && '飞机'}
          </span>
          {footer && <span className='bg-black/10 block mx-2 w-[1px] h-2.5' />}
          <span>
            {company}
            {no}
          </span>
          <span className='bg-black/10 block mx-2 w-[1px] h-2.5' />
          <span>{model}</span>

          <span className='flex-grow' />
          {headerRight}
        </header>
        <div className='flex items-center justify-between px-3 mt-3 relative'>
          <div>
            <b className='block font-[din] text-[23px] leading-none  text-gray-900 '>
              {startTimeText}
            </b>
            <span className='text-xs text-gray-700'>{startPosition}</span>
          </div>

          <div className='absolute left-0 right-0 mx-auto w-max'>
            <div className=' flex items-center '>
              {[0, 1, 2].map((item) => (
                <i
                  key={item}
                  className={`w-1 h-1 mr-1 ${
                    item === 0 ? 'bg-[#A1F4F9]' : ''
                  } ${item === 1 ? 'bg-[#87ECF2]' : ''} ${
                    item === 2 ? 'bg-[#6EE5EC]' : ''
                  } rounded-full block`}
                />
              ))}
              <span className='block text-gray-600 font-[500] bg-white/80 rounded-full text-xs  w-max px-2 py-0.5 mx-1'>
                {duration}
              </span>
              {[2, 1, 0].map((item) => (
                <i
                  key={item}
                  className={`w-1 h-1 ml-1 ${
                    item === 0 ? 'bg-[#A1F4F9]' : ''
                  } ${item === 1 ? 'bg-[#87ECF2]' : ''} ${
                    item === 2 ? 'bg-[#6EE5EC]' : ''
                  } rounded-full block`}
                />
              ))}
            </div>
            {stay && (
              <span className='text-gray-500 text-xs text-center block mt-1 scale-80'>
                {stay}
              </span>
            )}
          </div>

          <div className='text-right'>
            <b className='font-[din] text-[23px] leading-none relative block text-gray-900'>
              {endTimeText}
              {dayDiff ? (
                <span className='text-[12px] leading-none  absolute right-0 -top-3.5  scale-85 '>
                  +1
                </span>
              ) : (
                ''
              )}
            </b>
            <span className='text-xs text-gray-700'>{endPosition}</span>
          </div>
        </div>
        {footer}
      </article>
    );
  },
  isEqual
);

export default AirplaneCard;
